import {EmployeeDetailService} from "./service/employeeDetailService";
import {EmployeeProfileServiceModule} from "./EmployeeProfileServiceModuleConfiguration";

EmployeeProfileServiceModule
    .createNewModule()
    .service('EmployeeDetailService', ['$log', '$http', EmployeeDetailService]);